
import { Vue, Component } from "vue-property-decorator";
import { VNode } from "vue";
import panzoom from "panzoom";

@Component
export default class Mangnifiable extends Vue {
  private render(): VNode | undefined {
    if (this.$slots.default) {
      return this.$slots.default[0];
    }
  }

  private mounted(): void {
    panzoom(this.$el as HTMLElement, {
      maxZoom: 1,
      minZoom: 0.2,
      realPinch: true,
      onTouch: undefined,
      smoothScroll: false,
      beforeMouseDown: (e: MouseEvent) => {
        const shouldIgnore = !e.ctrlKey;
        return shouldIgnore;
      },
      beforeWheel: (e: WheelEvent) => {
        const shouldIgnore = !e.ctrlKey;
        return shouldIgnore;
      },
      onDoubleClick: () => {
        const shouldIgnore = true;
        return shouldIgnore;
      }
    });
  }
}
